import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import type { ChangeEvent, HTMLInputTypeAttribute } from 'react'
import { useId, useState } from 'react'

export type TextFieldProps = {
    label: string
    value: string
    onChange: (value: string) => void
    type?: HTMLInputTypeAttribute
    placeholder?: string
    error?: string
    helpText?: string
    required?: boolean
    disabled?: boolean
    autoComplete?: string
    autoFocus?: boolean
    inputMode?: 'text' | 'numeric' | 'decimal' | 'email' | 'tel'
    maxLength?: number
    min?: string | number
    max?: string | number
    step?: string | number
}

/**
 * Textové pole formuláře. V aplikaci se nikde nepoužívá holý <input> -
 * díky tomu vypadají popisky, chyby i velikost dotykové plochy všude stejně.
 */
export function TextField({ label, value, onChange, type = 'text', error, helpText, ...rest }: TextFieldProps) {
    const id = useId()
    // Heslo jde zobrazit - na mobilu se snadno překlepne a hvězdičky nic neprozradí.
    const jeHeslo = type === 'password'
    const [zobrazitHeslo, setZobrazitHeslo] = useState(false)

    const pole = (
        <Form.Control
            type={jeHeslo && zobrazitHeslo ? 'text' : type}
            value={value}
            isInvalid={!!error}
            className="su-tappable"
            onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
            {...rest}
        />
    )
    const chyba = error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>

    return (
        <Form.Group className="mb-3" controlId={id}>
            <Form.Label>{label}</Form.Label>
            {jeHeslo ? (
                <InputGroup hasValidation>
                    {pole}
                    <Button
                        variant="outline-secondary"
                        className="su-tappable"
                        aria-label={zobrazitHeslo ? 'Skrýt heslo' : 'Zobrazit heslo'}
                        aria-pressed={zobrazitHeslo}
                        title={zobrazitHeslo ? 'Skrýt heslo' : 'Zobrazit heslo'}
                        disabled={rest.disabled}
                        onClick={() => setZobrazitHeslo((soucasne) => !soucasne)}
                    >
                        <i className={`bi ${zobrazitHeslo ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true" />
                    </Button>
                    {chyba}
                </InputGroup>
            ) : (
                <>
                    {pole}
                    {chyba}
                </>
            )}
            {helpText && !error && <Form.Text className="text-muted">{helpText}</Form.Text>}
        </Form.Group>
    )
}
